module.exports = __webpack_public_path__ + "b47e6b262ea19a21ebaf9f9637951dec.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/clarityScale/I2@2x.png
// module id = 808
// module chunks = 0